import { looseClone } from "@/core/libs/helpers.lib";

const currencies = {
  methods: {
    formatNumbers(digit) {
      return digit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    drawCurrency(value) {
      value =
        value > 1000000 ? this.prettyText(value) : this.formatNumbers(value);

      let selectedDomains = this.$store.state.auth.selectedDomains;

      //console.log("selectedDomains", selectedDomains);

      //return value;

      if (
        !selectedDomains ||
        selectedDomains.length > 1 ||
        selectedDomains.length === 0
      ) {
        return value;
      }

      let domainObject = looseClone(selectedDomains).shift();

      //console.log("domainObject", domainObject);

      let domainsSettings = looseClone(this.$store.getters["domainsSettings"]);

      //console.log("domainsSettings", domainsSettings);

      let settings = domainsSettings
        .filter(item => item.domainId === domainObject.id)
        .shift();

      //console.log("settings", settings);

      if (!settings) {
        return value;
      }

      return settings.currencySymbolPosition === -1
        ? settings.currencySymbol + value
        : value + settings.currencySymbol;
    }
  },
  prettyText(digit) {
    let k = "";
    while (digit / 1000 > 1) {
      digit = Math.round((digit / 1000) * 100) / 100;
      k += "k";
    }
    return digit * 1 + k;
  }
};

export default currencies;
